import Navigation from './Navigation';
import Subsubmenu from './Subsubmenu';

document.addEventListener('DOMContentLoaded', () => {

  // Main nav

  let navigationElements = document.querySelectorAll('.js-navigation-item');
  if (!navigationElements) {
    return;
  }

  navigationElements.forEach((el) => {
    const navEls = new Navigation(el, {
      control:  el.querySelector('.js-navigation-control'),
      target: el.querySelector('.js-navigation-megamenu'),
      close: el.querySelector('.js-navigation-close'),
    });
    navEls.mount();
  })

  // Megamenu

  let megamenus = document.querySelectorAll('.js-navigation-megamenu');
  if (!megamenus.length) {
    return;
  }

  megamenus.forEach((el) => {
    const megamenuEls = new Subsubmenu(el, {});
    megamenuEls.mount();
  })

});
